function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocGolfFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28c-6.612 0-11.22-2.536-11.22-4.812 0-1.32 1.559-2.725 4.152-3.674v3.78h2v-4.366A22.686 22.686 0 0116 18.376c6.612 0 11.22 2.536 11.22 4.812C27.22 25.464 22.612 28 16 28zM10.932 4.623l5.845 2.945-5.845 1.301V4.623zM16 16.376c-1.806 0-3.514.181-5.068.504v-5.962l9.014-2.006a1 1 0 00.234-1.87l-9.798-4.936A1 1 0 008.932 3v14.41c-3.718 1.192-6.152 3.31-6.152 5.778C2.78 27.008 8.587 30 16 30s13.22-2.992 13.22-6.812c0-3.82-5.807-6.812-13.22-6.812z",
    fill: props.color
  }));
}

export default SvgIconPocGolfFilled;